import React, { useEffect, useState } from "react";
import style from "./Autocomplete.module.css";
import PropTypes from "prop-types";
import { Search } from "@mui/icons-material";
import { INPUT } from "./AutocompleteConstants";

function AutocompleteComponent({ data, onClick }) {
  const [inputValue, setInputValue] = useState("");
  const [showSuggestion, setShowSuggestion] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    setSuggestions(data.data);
  }, [data.data]);

  useEffect(() => {
    setShowSuggestion(!!suggestions.length);
  }, [suggestions]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  useEffect(() => {
    !!inputValue && fetchSuggestions(inputValue);
  }, [inputValue]);

  const fetchSuggestions = (inputValue) => {
    data.handleValues(inputValue);
  };

  const addTag = (item) => {
    onClick(item);
    setShowSuggestion(false);
    setInputValue("");
  };

  return (
    !!data && (
      <div className={style.formGroup}>
        {data.label && <label htmlFor={data.name}>{data.label}</label>}
        <div className={`${style.inputGroup} ${style[data.variant]}`}>
          <input
            id={data.id}
            name={data.name}
            className={`${style.input} ${data.disable && style.disable}`}
            type={INPUT.TYPE_TEXT}
            value={inputValue}
            onChange={handleInputChange}
            placeholder={data.placeholder}
            autoComplete="off"
          />
          <div className={style.icon}>
            <Search />
          </div>
        </div>
        {showSuggestion && (
          <div className={style.suggestion}>
            {suggestions.map((item, index) => (
              <span onClick={() => addTag(item)} key={index}>
                {item.number}-{item.name}
              </span>
            ))}
          </div>
        )}
      </div>
    )
  );
}

export default AutocompleteComponent;

AutocompleteComponent.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    disable: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    placeholder: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func,
};
